class Entity
{


    constructor(type)
    {
        this.app = PIXI.app;
        this.components = {};
        this.id = this.app.model.getUID();
        this.type = type;
    }


    addComponent(c, compType)
    {
        if (compType == undefined)
        {
            compType = c;
            compType.name = c.type;
        }
        this.components[compType.name] = c;
        c.entity = this;
    }


    getComponent(className)
    {
        return this.components[className.name];
    }


    getId()
    {
        return this.id;
    }


    getType()
    {
        return this.type;
    }


}


export default Entity;